import { PRODUCTION_TRANSACTION_REQUEST, GET_PRODUCTION_TRANSACTIONS, GET_PRODUCTION_TRANSACTIONS_TAKA_NO, PRODUCTION_TRANSACTION_REQUEST_FAILURE,
  GET_PRODUCTION_TRANSACTIONS_BY_BEAM, SET_SELECTED_BEAM, GET_PRODUCTION_TRANSACTIONS_WITH_SPECIFIC_COLUMNS
 } from '../types';

const initialState = {
  transactions: [],
  transactionsWithSpecificColumns: [],
  transByBeam: [],
  takaNos: [],
  selectedBeam: null,
  loading: false,
  error: null,
};

const productionTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case PRODUCTION_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_PRODUCTION_TRANSACTIONS: {
      return {
        ...state,
        transactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_PRODUCTION_TRANSACTIONS_WITH_SPECIFIC_COLUMNS: {
      const { data } = action.payload || {};
      return {
        ...state,
        transactionsWithSpecificColumns: [...data],
        loading: false,
        error: null
      }
    }
    case GET_PRODUCTION_TRANSACTIONS_TAKA_NO: {
      return {
        ...state,
        takaNos: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_PRODUCTION_TRANSACTIONS_BY_BEAM: {
      return {
        ...state,
        transByBeam: [...action.payload],
        loading: false,
        error: null
      }
    }
    case SET_SELECTED_BEAM: {
      return {
        ...state,
        selectedBeam: action.payload,
        loading: false,
        error: null
      }
    }
    case PRODUCTION_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default productionTransactionReducer;
